import {Vacature} from '../../models/vacature';
import {PublicatieStatus} from '../../models/publicatie-status';
import {Component, computed, inject, input, LOCALE_ID} from '@angular/core';
import {formatDate, NgClass} from '@angular/common';
import {OlaType} from '../../models/ola-type';
import {OlaNiveau} from '../../models/ola-niveau';
import {DATUM_FORMAT} from '../../app.config';

@Component({
  selector: 'mvw-vacature-detail',
  templateUrl: './vacature-detail.component.html',
  imports: [NgClass]
})
export class VacatureDetailComponent {

  private readonly locale = inject(LOCALE_ID);
  private readonly datumFormat = inject(DATUM_FORMAT);

  vacature = input.required<Vacature>();

  readonly status = computed(() => {
    switch (this.vacature().publicatieStatus) {
      case PublicatieStatus.Gepubliceerd: {
        return 'GEPUBLICEERD';
      }
      case PublicatieStatus.NietGepubliceerd: {
        return 'NIET GEPUBLICEERD';
      }
      case PublicatieStatus.Afgesloten: {
        return 'AFGESLOTEN';
      }
      default: {
        return '';
      }
    }
  });

  readonly isAfgesloten = computed(() => PublicatieStatus.Afgesloten === this.vacature().publicatieStatus);

  readonly heeftDatumIngevuld = computed(() =>
    !!(this.vacature().publicatieInformatie.startDatum ?? this.vacature().publicatieInformatie.eindDatum)
  );

  readonly toekomstigGepubliceerdMededeling = computed(() => {
    if (this.vacature().publicatieStatus !== PublicatieStatus.Gepubliceerd && this.heeftDatumIngevuld()) {
      return 'Gepubliceerd ';
    } else {
      return '';
    }
  });

  readonly publicatieInformatieVanTot = computed(() => {
    const {startDatum, eindDatum} = this.vacature().publicatieInformatie;
    if (startDatum && eindDatum) {
      return `van ${this.getFormatDate(startDatum)} tot ${this.getFormatDate(eindDatum)}`;
    } else if (startDatum) {
      return `van ${this.getFormatDate(startDatum)}`;
    } else if (eindDatum) {
      return `tot ${this.getFormatDate(eindDatum)}`;
    } else {
      return '';
    }
  });

  readonly heeftOla = computed(() => !!this.vacature().olaInformatie);

  readonly heeftMeerInfo = computed(() => !!this.vacature().olaInformatie?.isMeerInfoBeschikbaar);

  readonly olaType = computed(() => {
    if (this.vacature().olaInformatie) {
      switch (this.vacature().olaInformatie!.type) {
        case OlaType.ControleerHetGekozenJobdomein: {
          return 'Controleer het gekozen jobdomein.';
        }
        case OlaType.GeenAutomatischeVerzendingMogelijk: {
          return 'Geen automatische verzending mogelijk.';
        }
        case OlaType.GevraagdInhoudelijkNazichtBezig: {
          return 'Gevraagd inhoudelijk nazicht bezig.';
        }
        case OlaType.NietPubliceerbaar: {
          return 'Niet publiceerbaar.';
        }
        case OlaType.TegenstellingenGevonden: {
          return 'Tegenstellingen gevonden.';
        }
        default: {
          return '';
        }
      }
    }
    return '';
  });

  readonly olaNiveau = computed(() => {
    if (this.vacature().olaInformatie) {
      switch (this.vacature().olaInformatie!.niveau) {
        case OlaNiveau.ERROR: {
          return '-danger action-warning';
        }
        case OlaNiveau.WARNING: {
          return '-warning action-warning';
        }
        case OlaNiveau.INFO: {
          return '-info action-info';
        }
        default: {
          return '';
        }
      }
    }
    return '';
  });

  private getFormatDate(datum: Date): string {
    return formatDate(datum, this.datumFormat, this.locale);
  }

}
